<template>
  <div class="comment">
    <div class="comment-body">
      <div class="empty-tips" v-if="commentList.data.length === 0">
        <p>在下方输入留言吧～</p>
      </div>
      <div class="comment-item" v-for="item in commentList.data" :key="item.talkId">
        <div class="one-comment" :style="showTalkId === item.talkid ? 'background: #eee;' : ''">
          <div class="from">
            {{item.username}}
            <span class="from-detail">· {{item.time}}</span>
            <img class="reply-icon" @click="showComment(item.talkid)" src="https://images.vrm.cn/2019/07/15/message.png" alt="回复" title="回复">
          </div>
          <div class="word" v-html="item.text"></div>
          <div class="reply" v-show="showTalkId === item.talkid">
            <el-input
              ref="content"
              type="textarea"
              placeholder="请输入内容"
              v-model="content">
            </el-input>
            <el-button @click="doComment(item.talkid)" type="primary" size="small" class="send-btn" :disabled="content === ''">发送</el-button>
          </div>
        </div>
        <div class="follow-items" v-if="item.children.length > 0">
          <div class="follow word" v-for="follow in item.children" :key="follow.talkid">
            <div class="one-comment" :style="showTalkId === follow.talkid ? 'background: #eee;' : ''">
              <div class="from">
                {{follow.username}}
                <span class="from-detail">· {{follow.time}}</span>
                <!-- <img class="reply-icon" @click="showComment(follow.talkid)" src="https://images.vrm.cn/2019/07/15/message.png" alt="回复" title="回复"> -->
              </div>
              <div class="word" v-html="follow.text"></div>
              <div class="reply" v-show="showTalkId === follow.talkid">
                <el-input
                  ref="content"
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="content">
                </el-input>
                <el-button @click="doComment(follow.talkid)" type="primary" size="small" class="send-btn" :disabled="content === ''">发送</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reply-bottom">
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="parentContent">
      </el-input>
      <el-button @click="doComment(-1)" type="primary" size="small" class="send-btn" :disabled="parentContent === ''">发送</el-button>
    </div>
  </div>
</template>
<script>
import http from '@/plugins/axios'
export default {
  name: 'comment',
  data() {
    return {
      content: '',
      commentList: {
        data: []
      },
      showTalkId: null,
      parentContent: '',
      aboutid: -1
    }
  },
  mounted() {
    this.aboutid = location.href.split('/')[location.href.split('/').length - 1]
    this.getComment()
  },
  methods: {
    showComment(talkId) {
      this.$refs.content[0].focus()
      this.showTalkId = talkId
    },
    getComment() {
      http.post('/talk/get', {
        system: 'changjing',
        aboutid: this.aboutid
      }).then(res => {
        this.commentList = res.data
      })
      let commentBox = document.querySelector('.comment-body')
      commentBox.scrollTop = commentBox.scrollHeight
    },
    doComment(talkId) {
      const { content, parentContent, aboutid } = this
      let postData = {
        system: 'changjing',
        aboutid,
        parent: talkId,
        text: talkId === -1 ? parentContent : content
      }
      if (talkId === -1) {
        delete postData.parent
      }
      http.post('/talk/add', postData).then(res => {
        if (res.data.status === 'success') {
          this.parentContent = ''
          this.content = ''
          this.showTalkId = null
          this.getComment()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.comment {
  .same {
    margin-bottom: 10px;
  }
  .empty-tips {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #657786;
  }
  .comment-body {
    overflow: hidden;
    overflow-y: scroll;
    margin-right: -13px;
    padding: 10px;

    .comment-item {
      padding: 10px 0;
      border-bottom: 1px solid #eee;
      .one-comment {
        padding: 10px;
        border-radius: 4px;
        &:hover {
          background: #eee;
          transition: 1s all;
        }
      }
      .from{
        @extend .same;
        word-break: break-all;
        color: #14171a;
        font-size: 14px;
        font-weight: bold;
        .from-detail {
          font-size: 14px;
          color: #657786;
        }
      }
      .word {
        @extend .same;
        font-size: 14px;
        line-height: 20px;
      }
      .follow-items {
        border-left: 2px solid #aebecb;
        margin-left: 12px;
      }
      .reply-icon {
        width: 16px;
        cursor: pointer;
        float: right;
        margin-right: 10px;
      }
    }
  }
}
.reply {
  margin-top: 15px;
  padding: 10px 0 0;
  display: flex;
  align-items: flex-end;

  .send-btn {
    margin-left: 3px;
    padding: 7px;
  }
}
.reply-bottom {
  margin: 15px 0 20px 10px;
  padding: 10px 0 0;
  display: flex;
  align-items: flex-end;

  .send-btn {
    margin-left: 3px;
    padding: 7px;
    margin-right: 10px;
  }
}
.comment-body::-webkit-scrollbar { width: 0 !important }
</style>
